import BsDatePicker from "./BsDatePicker";

export default Vue => {
    Vue.component(BsDatePicker.name, BsDatePicker);
};
